import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import * as flags from 'country-flag-icons/react/3x2'; // eslint-disable-line import/no-extraneous-dependencies

function FlagIcon({ countryCode = null, currencyCode = null, className = '' }) {
  const { currencies: configCurrencies } = useSelector((state) => state.config);

  let resolvedCountryCode = countryCode;
  if (!resolvedCountryCode && currencyCode) {
    const normalizedCurrency = currencyCode.toUpperCase();
    if (normalizedCurrency === 'EUR') {
      resolvedCountryCode = 'EU';
    } else if (configCurrencies && configCurrencies.length > 0) {
      const currency = configCurrencies.find((c) => c.code === normalizedCurrency);
      if (currency) {
        if (currency.country && currency.country.code) {
          resolvedCountryCode = currency.country.code;
        } else if (currency.countries && Array.isArray(currency.countries) && currency.countries.length > 0) {
          resolvedCountryCode = currency.countries[0].code;
        }
      }
    }

    if (!resolvedCountryCode) {
      resolvedCountryCode = currencyCode;
    }
  }

  const code = resolvedCountryCode;

  if (code === 'WORLD') {
    return (
      <svg
        className={`inline-block ${className}`}
        width='24'
        height='18'
        viewBox='0 0 24 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        role='img'
        aria-label='International flag'
      >
        <rect width='24' height='18' fill='#4A90E2' />
        <circle cx='12' cy='9' r='6' fill='none' stroke='white' strokeWidth='1.5' />
        <line x1='12' y1='3' x2='12' y2='15' stroke='white' strokeWidth='1.5' />
        <ellipse cx='12' cy='9' rx='3' ry='6' fill='none' stroke='white' strokeWidth='1.5' />
      </svg>
    );
  }

  const FlagComponent = flags[code];

  if (!FlagComponent) {
    return (
      <div
        className={`inline-flex items-center justify-center bg-gray-200 text-gray-600 text-xs font-bold ${className}`}
        style={{ width: '24px', height: '18px' }}
        role='img'
        aria-label={`${code} flag`}
      >
        {code}
      </div>
    );
  }

  return <FlagComponent className={`inline-block ${className}`} title={`${code} flag`} />;
}

FlagIcon.propTypes = {
  countryCode: PropTypes.string,
  currencyCode: PropTypes.string,
  className: PropTypes.string,
};

export default FlagIcon;
